import { ethers } from 'ethers';
import TrustlinedERC4626ABI from './TrustlinedERC4626.json';

export const getContractByAddress = (provider: ethers.Provider, contractAddress: string) => {
  return new ethers.Contract(contractAddress, TrustlinedERC4626ABI, provider);
};

export const getSignerContractByAddress = (signer: ethers.Signer, contractAddress: string) => {
  return new ethers.Contract(contractAddress, TrustlinedERC4626ABI, signer);
};

export const formatAmount = (amount: string, decimals: number = 18): string => {
  return ethers.formatUnits(amount, decimals);
};

export const parseAmount = (amount: string, decimals: number = 18): string => {
  return ethers.parseUnits(amount, decimals).toString();
};

// ERC20 ABI for token symbol and decimals
const ERC20_ABI = [
  'function symbol() view returns (string)',
  'function decimals() view returns (uint8)'
];

// Cache for token symbols to avoid repeated calls
const tokenSymbolCache = new Map<string, string>();

export const getTokenSymbol = async (provider: ethers.Provider, tokenAddress: string): Promise<string> => {
  // Return ETH for zero address
  if (tokenAddress === ethers.ZeroAddress) {
    return 'ETH';
  }

  // Check cache first
  if (tokenSymbolCache.has(tokenAddress)) {
    return tokenSymbolCache.get(tokenAddress)!;
  }

  try {
    // Create ERC20 contract instance
    const tokenContract = new ethers.Contract(tokenAddress, ERC20_ABI, provider);
    
    // Fetch symbol
    const symbol = await tokenContract.symbol();
    
    // Cache the result
    tokenSymbolCache.set(tokenAddress, symbol);
    
    return symbol;
  } catch (error) {
    console.warn(`Failed to fetch symbol for token ${tokenAddress}:`, error);
    // Return generic fallback
    return 'Token';
  }
};

export const formatTimestamp = (timestamp: string): string => {
  if (timestamp === '0') {
    return 'Not completed yet';
  }
  
  const date = new Date(Number(timestamp) * 1000);
  return date.toLocaleString();
};
